var exports = {
  "n": "xa15a2ab7--3937ff--link",
};

module.exports = exports;
